import { createContext } from "react";

export const FocusContext = createContext<{
  isFocused: boolean;
  isDirectlyFocused: boolean;
  isPopupOrModalFocused: boolean;
}>({
  isFocused: false,
  isDirectlyFocused: false,
  isPopupOrModalFocused: false,
});
